import styled from 'styled-components';
import { colors } from '../../Utils/tokens';

export const IconButtonBase = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px;
  border: none;
  border-radius: 6px;
  background-color: ${({ $active }) => ($active ? colors.onSurfaceHover : 'transparent')};
  cursor: pointer;
  transition: background-color 0.15s ease;

  img {
    display: block;
    width: 16px;
    height: 16px;
  }

  &:hover,
  &:focus-visible {
    background-color: ${colors.onSurfaceHover};
    outline: none;
  }

  &:disabled {
    cursor: default;
    opacity: 0.5;

    &:hover {
      background-color: transparent;
    }
  }
`;
